import { Stack, TableCell, TableRow } from "@mui/material";
import { types } from "api";
import { StyledButton } from "components/StyledButton";
import { Link } from "react-router-dom";
import { getPath, routes } from "routes";

export interface ViewGroupsPageTableRowProps {
	row: types.Group;
}

// const PREFIX = "GroupTableRow";

export const GroupTableRow = ({
	row,
}: ViewGroupsPageTableRowProps): JSX.Element => {
	return (
		<TableRow hover role="checkbox" key={row.groupId}>
			<TableCell data-testid="groupName">
				<Stack direction="row" alignItems="center">
					{row.name}
				</Stack>
			</TableCell>
			<TableCell data-testid="lastName">{row.students.length}</TableCell>
			<TableCell data-testid="edit-action">
				<StyledButton
					variant="contained"
					color="primary"
					sx={{ marginRight: 2 }}
					component={Link}
					to={getPath(routes._.metrics._.Groups._.viewGroup, {
						groupId: row.groupId,
					})}
				>
					STUDENT LIST
				</StyledButton>
				<StyledButton
					variant="contained"
					color="primary"
					sx={{ marginRight: 2 }}
					component={Link}
					to={getPath(routes._.metrics._.viewGroupMetrics, {
						groupId: row.groupId,
					})}
				>
					VIEW METRICS
				</StyledButton>
			</TableCell>
		</TableRow>
	);
};
